// extracted by mini-css-extract-plugin
export default {"title":"AddNotification_title__qyeOD","boxForm":"AddNotification_boxForm__Hc5+5","form":"AddNotification_form__CdwJT"};